import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {RegisterSetting} from '../models/register-setting';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {RequestOptions} from '@angular/http';
import {JwtHelper} from 'angular2-jwt';
import {tap} from 'rxjs/operators';

const host = environment.apiURL;

export interface Authentication {
  readonly name: string;
  readonly username: string;
  readonly email: string;
  readonly expire: number;
  readonly id: boolean;
  readonly group_id: boolean;
}

@Injectable()
export class AuthenticationService {
  public data: Authentication;
  private jwtHelper = new JwtHelper();
  private options: any;
  public redirectUrl: string;

  constructor(private http: HttpClient) {
    this.options = new RequestOptions();
    this.options.headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8', 'Accept': 'application/json' });
  }

  private static saveToken(res: any) {
    localStorage.setItem('access_token', JSON.stringify(res));
  }

  private static saveAuthModel(data: Authentication) {
    localStorage.setItem('auth_model', JSON.stringify(data));
  }

  // Get access token from Local Storage
  public getCurrentToken() {
    if (!localStorage['access_token']) {
      return;
    }
    return JSON.parse(localStorage['access_token']);
  }

  public getAuthModel() {
    if (!localStorage['auth_model']) {
      return;
    }
    return JSON.parse(localStorage['auth_model']);
  }

  public isUnExpired(): boolean {
    return this.data && new Date().getTime() / 1000 < this.data.expire;
  }

  public login(username: string, password: string): Observable<any> {
    return this.http.post(host + '/api/auth/login', JSON.stringify({username: username, password: password}), this.options)
      .pipe(tap(res => this.setToken(res)));
  }

  public setToken(authResult) {
    AuthenticationService.saveToken(authResult['access_token']);
    this.data = this.toAuthenticationModel(authResult['access_token']);
    AuthenticationService.saveAuthModel(this.data);
  }

  register(model: RegisterSetting): Observable<any> {
    return Observable.create(subscribe => {
      this.http.post(host + '/api/auth/register', JSON.stringify(model), this.options)
        .subscribe(res => {
          subscribe.next(res);
          subscribe.complete();
        }, error => {
          subscribe.error(error);
        });
    });
  }

  isLogin(): boolean {
    try {
      const accessToken = this.getCurrentToken();
      let unExpired = true;
      if (accessToken && !this.data) {
        this.data = this.toAuthenticationModel(accessToken);
        AuthenticationService.saveAuthModel(this.data);
        unExpired = this.isUnExpired();
        console.log('*** expire: ', !unExpired);
      }
      const judge = accessToken && 0 < accessToken.length && unExpired;
      if (!judge) {
        this.clearToken();
        return false;
      }
      this.data = this.toAuthenticationModel(accessToken);
      AuthenticationService.saveAuthModel(this.data);

      return judge;

    } catch (e) {
      // ignore
    }
    return false;
  }

  public toAuthenticationModel(accessToken: any): any {
    const decoded = this.jwtHelper.decodeToken(accessToken);
    return {
      name: decoded.user.name,
      username: decoded.user.user_name,
      email: decoded.user.email,
      id: decoded.user.id,
      group_id: decoded.user.group_id,
      expire: decoded.exp
    };
  }

  clearToken(): void {
    this.data = null;
    localStorage.removeItem('access_token');
    localStorage.removeItem('auth_model');
  }

  forgotPassword(email: string): Observable<any> {
    return new Observable(observer => {
      this.http.post(host + '/api/auth/forgot_password', JSON.stringify({email: email}), this.options)
        .subscribe((response) => {
        observer.next(response);
        observer.complete();
      }, (error) => {
        observer.error(error);
      });
    });
  }

  resetPassword(model: any): Observable<any> {
    return new Observable(observer => {
      this.http.post(host + '/api/auth/password/reset', JSON.stringify(model), this.options)
        .subscribe((response) => {
          observer.next(response);
          observer.complete();
        }, (error) => {
          observer.error(error);
        });
    });
  }

  logout(): Observable<any> {
    return new Observable(observer => {
      this.http.get(host + '/api/auth/logout', this.options)
        .subscribe((response) => {
          observer.next();
          observer.complete();
        }, (error) => {
          observer.error(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/authentication.service.ts